import { css } from '@emotion/react';
import { ShortRule } from 'shared';

import { SasIcon } from '../SasIcon';
import { theme } from '../theme';

const styles = {
  shortRuleListItem: css`
    width: 100%;
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
  `,
  shortRuleListItemText: css`
    padding-left: 8px;
    text-align: left;
    font-size: ${theme.fontSize.xs};
  `,
};

type Props = { rule: ShortRule };

export function ShortRuleItem({ rule }: Props) {
  const { iconName, text } = rule;

  return (
    <li css={styles.shortRuleListItem}>
      <SasIcon name={iconName} />
      <div css={styles.shortRuleListItemText}>{text}</div>
    </li>
  );
}
